import * as actions from './actions';
import * as types from './types';
import reducer from './reducers';

export default reducer;
export {
  actions,
  reducer,
  types,
};
